<template>
<div>
    <b-card no-body>
    <b-tabs card>
      <b-tab title="Product Sharing" active>
      <div>
      <p class="mt-3">Products(Share the product link to other users, you will get a certain percentage of commission).</p>
      <b-button-group class="table-responsive mt-3">
        <b-button :variant="track_lan=='en'?'success':'info'" @click="changeLan('en')">English</b-button>
        <b-button :variant="track_lan=='cn'?'success':'info'" @click="changeLan('cn')">中文</b-button>
        <b-button :variant="track_lan=='de'?'success':'info'" @click="changeLan('de')">Deutsche</b-button>
        <b-button :variant="track_lan=='fr'?'success':'info'" @click="changeLan('fr')">Français</b-button>
        <b-button :variant="track_lan=='es'?'success':'info'" @click="changeLan('es')">Español</b-button>
        <b-button :variant="track_lan=='it'?'success':'info'" @click="changeLan('it')">Italiano</b-button>
        <b-button :variant="track_lan=='ru'?'success':'info'" @click="changeLan('ru')">Pусский</b-button>
        <b-button :variant="track_lan=='tr'?'success':'info'" @click="changeLan('tr')">Türk</b-button>
        <b-button :variant="track_lan=='pl'?'success':'info'" @click="changeLan('pl')">Polskie</b-button>
        <b-button :variant="track_lan=='jp'?'success':'info'" @click="changeLan('jp')">日本語</b-button>
        <b-button :variant="track_lan=='kr'?'success':'info'" @click="changeLan('kr')">한국어</b-button>
        <b-button :variant="track_lan=='in'?'success':'info'" @click="changeLan('in')">हिंदी</b-button>
        <b-button :variant="track_lan=='vn'?'success':'info'" @click="changeLan('vn')">Việt</b-button>
        <b-button :variant="track_lan=='th'?'success':'info'" @click="changeLan('th')">ภาษาไทย</b-button>
        <b-button :variant="track_lan=='my'?'success':'info'" @click="changeLan('my')">Malay</b-button>
        <b-button :variant="track_lan=='id'?'success':'info'" @click="changeLan('id')">Indonesia</b-button>
        <b-button :variant="track_lan=='ph'?'success':'info'" @click="changeLan('ph')">Pilipino</b-button>
        <b-button :variant="track_lan=='sa'?'success':'info'" @click="changeLan('sa')"> عربي ،</b-button>
      </b-button-group>
      <!--Products(Share the product link to other users, you will get a certain percentage of commission)
          
          <b-nav-item-dropdown id="dropdown-right" variant="primary" :text="'<span class="flag-icon flag-icon-us"></span>'+langgg" class="mt-1">
            <b-dropdown-item @click="changeLan('en')"><span class="flag-icon flag-icon-us"></span>&nbsp;United States</b-dropdown-item>
            <b-dropdown-item @click="changeLan('cn')"><span class="flag-icon flag-icon-cn"></span>&nbsp;中国</b-dropdown-item>
            <b-dropdown-item @click="changeLan('de')"><span class="flag-icon flag-icon-de"></span>&nbsp;Deutschland</b-dropdown-item>
            <b-dropdown-item @click="changeLan('fr')"><span class="flag-icon flag-icon-fr"></span>&nbsp;France</b-dropdown-item>
            <b-dropdown-item @click="changeLan('es')"><span class="flag-icon flag-icon-es"></span>&nbsp;España</b-dropdown-item>
            <b-dropdown-item @click="changeLan('it')"><span class="flag-icon flag-icon-it"></span>&nbsp;Italia</b-dropdown-item>
            <b-dropdown-item @click="changeLan('ru')"><span class="flag-icon flag-icon-ru"></span>&nbsp;Россия</b-dropdown-item>
            <b-dropdown-item @click="changeLan('tr')"><span class="flag-icon flag-icon-tr"></span>&nbsp;Türkiye</b-dropdown-item>
            <b-dropdown-item @click="changeLan('pl')"><span class="flag-icon flag-icon-pl"></span>&nbsp;Polska</b-dropdown-item>
            <b-dropdown-item @click="changeLan('jp')"><span class="flag-icon flag-icon-jp"></span>&nbsp;日本</b-dropdown-item>
            <b-dropdown-item @click="changeLan('kr')"><span class="flag-icon flag-icon-kr"></span>&nbsp;대한민국</b-dropdown-item>
            <b-dropdown-item @click="changeLan('in')"><span class="flag-icon flag-icon-in"></span>&nbsp;India</b-dropdown-item>
            <b-dropdown-item @click="changeLan('vn')"><span class="flag-icon flag-icon-vn"></span>&nbsp;Việt Nam</b-dropdown-item>
            <b-dropdown-item @click="changeLan('th')"><span class="flag-icon flag-icon-th"></span>&nbsp;ประเทศไทย</b-dropdown-item>
            <b-dropdown-item @click="changeLan('my')"><span class="flag-icon flag-icon-my"></span>&nbsp;Horai Nishigo</b-dropdown-item>
            <b-dropdown-item @click="changeLan('id')"><span class="flag-icon flag-icon-id"></span>&nbsp;Inzai</b-dropdown-item>
            <b-dropdown-item@click="changeLan('ph')"><span class="flag-icon flag-icon-ph"></span>&nbsp;Disiplina</b-dropdown-item>
            <b-dropdown-item @click="changeLan('sa')"><span class="flag-icon flag-icon-sa"></span>&nbsp;مملكة عربية سعودية</b-dropdown-item>
        </b-nav-item-dropdown>-->
        
      </div>
        
        <b-card-text>
        <div class="overflow-auto">
          <b-table sticky-header :items="products" :fields="fields2" head-variant="light">
          </b-table>
          </div>
        </b-card-text>
      </b-tab>
      <b-tab title="Commission">
      
      <div>
          <b-form-select v-model="month" :options="options" class="mt-3" @change="changeDate()"></b-form-select>
          <p class="mt-3">Commission Total: <span style="color:red;font-weight:bold;"> {{ amount }} USD</span></p>
      </div>
        <b-card-text>
        <div class="overflow-auto">
          <b-table
            id="my-table"
            :items="items"
            :fields="fields"
            :per-page="perPage"
            :current-page="'1'"
             head-variant="light"
          ></b-table>

          <b-pagination
            v-model="currentPage"
            size="lg"
            :total-rows="rows"
            :per-page="perPage"
            @change="change"
            aria-controls="my-table"
          ></b-pagination>
          </div>
        </b-card-text>
      </b-tab>
    </b-tabs>
  </b-card>
</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import VueMonthCalendar from 'vue-month-calendar';
export default {
    name: "TrackList",
     data() {
        return {
        amount:0.00,
        amount2:0.00,   
        perPage: 20,
        currentPage: 1,
        rows: 0,
        langgg: '',
        track_lan: 'en',
        month: '',
        // options: [
        //   { value: '2020-08', text: '2020-08' },
        //   { value: '2020-07', text: '2020-07' },
        //   { value: '2020-06', text: '2020-06' },
        //   { value: '2020-05', text: '2020-05' }
        // ],
        options: [],
        fields: [
          {
            key: 'payno',
            label: 'Order number',
            sortable: false
          },
          {
            key: 'amount',
            label: 'Commission amount(USD)',
            sortable: false
          },
          {
            key: 'createat',
            label: 'Date',
            sortable: false,
            formatter: (value, key, item) => {
              let date = new Date(item.createat);
              return date.getFullYear() +'-' +date.getMonth()+'-' +date.getDay();
            }
          }  
        ],
        fields2: [
          {
            key: 'productname',
            label: 'Product name',
            sortable: false
          },
          {
            key: 'scale',
            label: 'Commission ratio',
            sortable: false
          },
          {
            key: 'url',
            label: 'Referral link',
            sortable: false
          }
        ],
        items: [],
        products:[]
        }
     },
    computed: {
    ...mapGetters([
      "lan_array"
    ])
  },
    created() {
      this.initDateSelect();
      this.getTrackList(this.month,this.currentPage-1,this.perPage);
      // this.track_lan = localStorage.getItem('site_track_location');
      this.displayLangg(localStorage.getItem('site_track_location'));
      this.getTrackProductList(localStorage.getItem('site_track_location'));
    },

    
    methods: {
        ...mapActions({
          getTrackList(dispatch, month, pg, pgs) {
            dispatch("getTrackList", { month, pg, pgs }).then(data => {
              if (data.result) {
                this.amount = data.amount;
                this.amount2 = data.amount2;
                this.rows = data.total;
                this.items = data.items;
              }else{
                this.toTrackHome();
              }
            });
        },
         getTrackProductList(dispatch,location) {
            dispatch("getTrackProductList",{location}).then(data => {
              if (data.result) {
                this.products = data.items;
              }
            });
        },
        }),
        change(page){
          this.currentPage = page;
          this.getTrackList(this.month,this.currentPage-1,this.perPage);
        },
        changeLan(langggg){
          localStorage.setItem("site_track_location", langggg);
          this.displayLangg(langggg);
          this.getTrackProductList(langggg);
        },
        displayLangg(lg){
          this.track_lan = lg;
          this.langgg = "United States";
          if (lg == "cn"){
            this.langgg = "中国";
          }else if(lg == "de"){
            this.langgg = "Deutschland";
          }else if(lg == "fr"){
            this.langgg = "France";
          }else if(lg == "es"){
            this.langgg = "España";
          }else if(lg == "it"){
            this.langgg = "Italia";
          }else if(lg == "ru"){
            this.langgg = "Россия";
          }else if(lg == "tr"){
            this.langgg = "Türkiye";
          }else if(lg == "pl"){
            this.langgg = "Polska";
          }else if(lg == "jp"){
            this.langgg = "日本";
          }else if(lg == "kr"){
            this.langgg = "대한민국";
          }else if(lg == "in"){
            this.langgg = "India";
          }else if(lg == "vn"){
            this.langgg = "Việt Nam";
          }else if(lg == "th"){
            this.langgg = "ประเทศไทย";
          }else if(lg == "my"){
            this.langgg = "Horai Nishigo";
          }else if(lg == "id"){
            this.langgg = "Inzai";
          }else if(lg == "ph"){
            this.langgg = "Disiplina";
          }else if(lg == "sa"){
            this.langgg = "مملكة عربية سعودية";
          }
        },
        toTrackHome() {
            this.$router.push({
                name: "TrackLogin",
            });
        },
        changeDate(){
          this.currentPage = 1;
          this.getTrackList(this.month,this.currentPage-1,this.perPage);
        },
      showToast(msg) {
      this.$bvToast.toast(msg, {
        title: ``,
        toaster: "b-toaster-bottom-center",
        solid: true,
        variant: "danger",
        appendToast: false
      });
    },

    initDateSelect(){
      let enddate = new Date();
      let startdate = new Date('2020-07-01');
      let endyear = enddate.getFullYear();
      let endmonth = enddate.getMonth()+1;
      endmonth = endmonth<10?'0'+endmonth:endmonth;
      this.month = endyear+'-'+endmonth;
      
      let startyear = startdate.getFullYear();
      let startmonth = startdate.getMonth()+1;
      let months = (endyear - startyear)*12 + (endmonth - startmonth + 1);
      this.options.length = 0;
      for(var i=0;i<months;i++){
        let thedate = new Date();
        thedate.setMonth(thedate.getMonth()-i);
        let themonth = thedate.getMonth()+1;
        let dateStr = thedate.getFullYear() + '-' + (themonth<10?'0'+themonth:themonth);
        this.options.push({ value: dateStr, text: dateStr });
      }
    },
    }
    

};
</script>